m.connect({
    name: 'widgets',
    isLoaded: function () {
        return window.widgetsLoaded;
    },
    loadStyle: function (href) {
        const link = document.createElement('link');

        link.rel = 'stylesheet';
        link.href = m.host.widgets + href + '?ver=' + m.about.BUILD_VERSION;

        document.body.appendChild(link);
    },
    loadScript: function (src) {
        const script = document.createElement('script');

        if (src.endsWith('scripts.js')) {
            script.defer = true;
            script.noModule = true
        } else {
            script.type = 'module';
        }

        script.src = m.host.widgets + src + '?ver=' + m.about.BUILD_VERSION;

        document.body.appendChild(script);
    },
    load: function () {
        const styles = [
            '/components/web-components/build/assets/icons/css/icons.css',
            '/components/web-components/build/styles.css',
            '/components/web-components/build/wc1-theme.css'
        ];

        const scripts = [
            '/components/web-components/build/runtime.js',
            '/components/web-components/build/polyfills.js',
            '/components/web-components/build/scripts.js',
            '/components/web-components/build/vendor.js',
            '/components/web-components/build/main.js',
        ];

        styles.forEach(this.loadStyle);
        scripts.forEach(this.loadScript);
        window.widgetsLoaded = true;
    }
});
